export enum GoverningBody {
	Ofsted = "Ofsted",
	Estyn = "Estyn",
}
